import React from 'react';
import { FileTextIcon, CalendarIcon, UserIcon, DollarSignIcon, ExternalLinkIcon, ClipboardIcon } from 'lucide-react';
export function Header() {
  return <header className="w-full bg-white border-b border-gray-200 shadow-sm" data-id="element-86">
      <div className="px-6 py-5" data-id="element-87">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-88">
          Tilbudsoverblik – Roth
        </h1>
        <div className="mt-4 flex flex-col md:flex-row justify-between" data-id="element-89">
          <div className="space-y-2" data-id="element-90">
            <div data-id="element-91">
              <h2 className="text-xl font-semibold text-gray-700" data-id="element-92">
                Gulvvarme – Villa 180 m²
              </h2>
              <p className="text-gray-500" data-id="element-93">Q-2025-0417</p>
            </div>
          </div>
          <div className="mt-4 md:mt-0 flex flex-wrap gap-2" data-id="element-94">
            <InfoChip icon={<UserIcon size={14} data-id="element-96" />} label="Kunde" value="VVS Partner A/S" data-id="element-95" />
            <InfoChip icon={<UserIcon size={14} data-id="element-98" />} label="Sælger" value="Anders Jensen" data-id="element-97" />
            <InfoChip icon={<DollarSignIcon size={14} data-id="element-100" />} label="Valuta" value="DKK" data-id="element-99" />
            <InfoChip icon={<CalendarIcon size={14} data-id="element-102" />} label="Gyldig til" value="31-12-2025" data-id="element-101" />
            <InfoChip icon={<ExternalLinkIcon size={14} data-id="element-104" />} label="Forberedt i ekstern kilde • 14:35" className="bg-blue-50 text-blue-700 border-blue-200" data-id="element-103" />
            <InfoChip icon={<ClipboardIcon size={14} data-id="element-106" />} label="Klar til gennemgang" className="bg-amber-50 text-amber-700 border-amber-200" data-id="element-105" />
          </div>
        </div>
      </div>
    </header>;
}
interface InfoChipProps {
  icon: React.ReactNode;
  label: string;
  value?: string;
  className?: string;
}
function InfoChip({
  icon,
  label,
  value,
  className = 'bg-gray-100 text-gray-700 border-gray-200'
}: InfoChipProps) {
  return <div className={`px-3 py-1.5 rounded-full text-xs font-medium border flex items-center gap-1.5 ${className}`} data-id="element-107">
      {icon}
      {value ? <>
          <span className="text-gray-500" data-id="element-108">{label}:</span> {value}
        </> : <span data-id="element-109">{label}</span>}
    </div>;
}